"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var universal_purify_1 = require("../universal_purify");
var I18n = require("i18n-js");
var React = require("react");
var react_router_1 = require("react-router");
var bind_1 = require("../bind");
var lodash_1 = require("lodash");
exports.ALLOWED_TAGS = [
    'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'span', 'br',
];
exports.ALLOWED_ATTRIBUTES = [
    'class', 'itemprop', 'itemscope', 'itemtype',
    'href', 'name', 'target',
    'src',
];
var INLINE_LEVEL_TAGS = [
    'a', 'b', 'i', 'strong', 'em', 'strike', 'span',
];
var SanitizedRender = /** @class */ (function (_super) {
    tslib_1.__extends(SanitizedRender, _super);
    function SanitizedRender() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            truncateByCharacter: !!_this.props.truncationLimit,
            truncateByHeight: !!_this.props.truncationHeight,
        };
        return _this;
    }
    SanitizedRender.prototype.breakLongURLs = function (clean) {
        if (!this.props.breakLongURLs) {
            return clean;
        }
        return clean.replace(/(\.|\/)/g, '<wbr>$1');
    };
    SanitizedRender.prototype.convertNewlines = function (clean) {
        if (!this.props.convertNewlines) {
            return clean;
        }
        return clean.replace(/\n/g, '<br>');
    };
    SanitizedRender.prototype.shouldTruncateByCharacter = function () {
        return this.couldTruncateByCharacter() && this.state.truncateByCharacter;
    };
    SanitizedRender.prototype.couldTruncateByCharacter = function () {
        var cleanedLength = this.getCleanText().length;
        return (cleanedLength > this.props.truncationLimit
            && !(cleanedLength <= this.props.truncationLimit * (1 + this.props.truncationWiggle)));
    };
    SanitizedRender.prototype.toggleTruncationByCharacter = function () {
        this.setState({ truncateByCharacter: !this.state.truncateByCharacter });
    };
    SanitizedRender.prototype.toggleTruncateByHeight = function () {
        this.setState({ truncateByHeight: !this.state.truncateByHeight });
    };
    SanitizedRender.prototype.allowedAttributes = function () {
        return this.props.allowedAttributes;
    };
    SanitizedRender.prototype.allowedTags = function () {
        if (this.props.inlineTagsOnly) {
            return lodash_1.difference(INLINE_LEVEL_TAGS, this.props.blacklistedTags);
        }
        return lodash_1.difference(this.props.allowedTags, this.props.blacklistedTags);
    };
    SanitizedRender.prototype.couldTruncateByHeight = function () {
        // this is dumb right now but we should revisit checking this element's full height
        // against a control element to conditionally render the 'read more' link
        // (would have to remeasure on window resize, etc etc)
        return this.props.truncationHeight !== undefined;
    };
    SanitizedRender.prototype.truncateByHeightStyle = function () {
        if (!this.couldTruncateByHeight() || !this.state.truncateByHeight)
            return;
        return {
            maxHeight: this.props.truncationHeight,
        };
    };
    SanitizedRender.prototype.truncateByHeightAttr = function () {
        if (!this.couldTruncateByHeight())
            return;
        return {
            'data-truncate-with-fade': this.state.truncateByHeight,
        };
    };
    SanitizedRender.prototype.getCleanText = function () {
        var clean = universal_purify_1.default.sanitize(this.props.html, {
            ALLOWED_ATTR: this.allowedAttributes(),
            ALLOWED_TAGS: this.allowedTags(),
        });
        return this.convertNewlines(this.breakLongURLs(clean));
    };
    SanitizedRender.prototype.getTruncatedText = function () {
        if (!this.state.truncateByCharacter || !this.couldTruncateByCharacter())
            return this.getCleanText();
        var truncated = this.getCleanText().slice(0, this.props.truncationLimit);
        return universal_purify_1.default.sanitize(truncated).concat('…');
    };
    SanitizedRender.prototype.renderTruncationToggle = function () {
        if (!this.couldTruncateByCharacter())
            return;
        if (this.state.truncateByCharacter && this.props.readMoreUrl) {
            return (React.createElement(react_router_1.Link, { className: "ml-space size-80", to: this.props.readMoreUrl }, I18n.t('commons.sanitizedRender.expand')));
        }
        return (React.createElement("button", { className: "button-as-link ml-space size-80", onClick: this.toggleTruncationByCharacter }, I18n.t("commons.sanitizedRender." + (this.state.truncateByCharacter ? 'expand' : 'collapse'))));
    };
    SanitizedRender.prototype.renderTruncateByHeightToggle = function () {
        if (!this.couldTruncateByHeight())
            return;
        var key = this.state.truncateByHeight ? 'expandEllipsis' : 'collapse';
        if (this.props.readMoreUrl === '#') {
            return (React.createElement("button", { className: "ml-space size-80 button-as-link" }, I18n.t('commons.sanitizedRender.expandEllipsis')));
        }
        if (this.props.readMoreUrl) {
            return (React.createElement(react_router_1.Link, { className: "ml-space size-80", to: this.props.readMoreUrl }, I18n.t('commons.sanitizedRender.expandEllipsis')));
        }
        return (React.createElement("button", { className: "button-as-link mt-1", onClick: this.toggleTruncateByHeight }, I18n.t("commons.sanitizedRender." + key)));
    };
    SanitizedRender.prototype.render = function () {
        var html = this.props.html;
        if (!html)
            return null;
        var Tag = (this.props.htmlTag || 'span');
        if (this.props.truncationLimit) {
            return (React.createElement(Tag, { className: this.props.className, id: this.props.id },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: this.getTruncatedText() } }),
                this.renderTruncationToggle()));
        }
        if (this.couldTruncateByHeight()) {
            return (React.createElement("div", { className: this.props.className, id: this.props.id },
                React.createElement("div", tslib_1.__assign({ dangerouslySetInnerHTML: { __html: this.getCleanText() } }, this.truncateByHeightAttr(), { style: this.truncateByHeightStyle() })),
                this.renderTruncateByHeightToggle()));
        }
        return (React.createElement(Tag, { className: this.props.className, dangerouslySetInnerHTML: { __html: this.getCleanText() }, id: this.props.id }));
    };
    SanitizedRender.defaultProps = {
        allowedTags: exports.ALLOWED_TAGS,
        allowedAttributes: exports.ALLOWED_ATTRIBUTES,
        blacklistedTags: [],
        truncationWiggle: 0.25,
    };
    tslib_1.__decorate([
        bind_1.default
    ], SanitizedRender.prototype, "toggleTruncationByCharacter", null);
    tslib_1.__decorate([
        bind_1.default
    ], SanitizedRender.prototype, "toggleTruncateByHeight", null);
    return SanitizedRender;
}(React.Component));
exports.default = SanitizedRender;
//# sourceMappingURL=sanitized_render.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/sanitized_render.js
// module id = y84n
// module chunks = 20 21